import Welcome from "./Welcome"
import Intro from "./Intro"
import Contact from "./Contact"
import Footer from "./Footer"


function Home() {

    return (  
      <div>
        <Welcome />
        <Intro />
        <Contact />
        <Footer />
      </div>       
    ) 
  };
  
  export default Home;